var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alerts",class:Object.assign({}, _vm.$desktopModeStyles,
      {'no-toolbar': _vm.isLoginPage && _vm.$vuetify.breakpoint.xsOnly})},_vm._l((_vm.alerts),function(alert){return _c('alert',{key:alert.id,attrs:{"id":alert.id,"icon":alert.icon,"message":alert.message,"link":alert.link,"translate":alert.translate,"color":alert.color,"timeout":alert.timeout,"hjsuppress":alert.hjsuppress}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Alerts.vue?vue&type=template&id=51442551&scoped=true&
// module id = 2790
// module chunks = 5